import { legacy_createStore as createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";

export const configureStore = (rootReducer, rootSaga) => {
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [sagaMiddleware];
  const composedEnhancers = compose(applyMiddleware(...middleware));

  const store = createStore(rootReducer, composedEnhancers);
  sagaMiddleware.run(rootSaga);
  return store;
};

